import apiClient from '../../../api/client';
import type {
  VisitaCobroResponse,
  VisitaStatsResponse,
  CreateVisitaDto,
  QueryVisitasDto,
  Paginated,
} from '@aid/shared';

export type { VisitaCobroResponse, VisitaStatsResponse, CreateVisitaDto, QueryVisitasDto };

export async function getVisitas(params: QueryVisitasDto): Promise<Paginated<VisitaCobroResponse>> {
  const { data } = await apiClient.get<Paginated<VisitaCobroResponse>>('/admin/visitas', {
    params,
  });
  return data;
}

export async function getVisitasStats(
  params: Omit<QueryVisitasDto, 'offset' | 'limit'>,
): Promise<VisitaStatsResponse> {
  const { data } = await apiClient.get<VisitaStatsResponse>('/admin/visitas/stats', { params });
  return data;
}

export async function createVisita(dto: CreateVisitaDto): Promise<VisitaCobroResponse> {
  const { data } = await apiClient.post<VisitaCobroResponse>('/admin/visitas', dto);
  return data;
}
